import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=5153e7ed&"
import script from "./Search.vue?vue&type=script&lang=ts&"
export * from "./Search.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5153e7ed')) {
      api.createRecord('5153e7ed', component.options)
    } else {
      api.reload('5153e7ed', component.options)
    }
    module.hot.accept("./Search.vue?vue&type=template&id=5153e7ed&", function () {
      api.rerender('5153e7ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/Search.vue"
export default component.exports